// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DOM__Node$SmartcutsMacros = require("../DOM__Node.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");

function range_encode(encoder_domNode, v) {
  return Js_dict.fromArray([
              [
                "rootNode",
                Curry._1(encoder_domNode, v.rootNode)
              ],
              [
                "startNode",
                Curry._1(encoder_domNode, v.startNode)
              ],
              [
                "startOffset",
                Decco.intToJson(v.startOffset)
              ],
              [
                "endNode",
                Curry._1(encoder_domNode, v.endNode)
              ],
              [
                "endOffset",
                Decco.intToJson(v.endOffset)
              ],
              [
                "collapsed",
                Decco.boolToJson(v.collapsed)
              ],
              [
                "selectedText",
                Decco.stringToJson(v.selectedText)
              ]
            ]);
}

function range_decode(decoder_domNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rootNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rootNode"), null));
  if (rootNode.TAG === /* Ok */0) {
    var startNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startNode"), null));
    if (startNode.TAG === /* Ok */0) {
      var startOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startOffset"), null));
      if (startOffset.TAG === /* Ok */0) {
        var endNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "endNode"), null));
        if (endNode.TAG === /* Ok */0) {
          var endOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endOffset"), null));
          if (endOffset.TAG === /* Ok */0) {
            var collapsed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "collapsed"), null));
            if (collapsed.TAG === /* Ok */0) {
              var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
              if (selectedText.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          rootNode: rootNode._0,
                          startNode: startNode._0,
                          startOffset: startOffset._0,
                          endNode: endNode._0,
                          endOffset: endOffset._0,
                          collapsed: collapsed._0,
                          selectedText: selectedText._0
                        }
                      };
              }
              var e = selectedText._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".selectedText" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = collapsed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".collapsed" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = endOffset._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".endOffset" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = endNode._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".endNode" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = startOffset._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".startOffset" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = startNode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".startNode" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = rootNode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rootNode" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function t_encode(encoder_domNode, v) {
  if (v) {
    return [
            "Range",
            range_encode(encoder_domNode, v._0)
          ];
  } else {
    return ["NoRange"];
  }
}

function t_decode(decoder_domNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NoRange" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoRange */0
                  };
          }
      case "Range" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = range_decode(decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Range */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapRange(mapDomNode, param) {
  return {
          rootNode: Curry._1(mapDomNode, param.rootNode),
          startNode: Curry._1(mapDomNode, param.startNode),
          startOffset: param.startOffset,
          endNode: Curry._1(mapDomNode, param.endNode),
          endOffset: param.endOffset,
          collapsed: param.collapsed,
          selectedText: param.selectedText
        };
}

function stringifyRange(stringifyDomNode, param) {
  return "{rootNode: " + (Curry._1(stringifyDomNode, param.rootNode) + (", startNode: " + (Curry._1(stringifyDomNode, param.startNode) + (", startOffset: " + (String(param.startOffset) + (", endNode: " + (Curry._1(stringifyDomNode, param.endNode) + (", endOffset: " + (String(param.endOffset) + (", collapsed: " + (Pervasives.string_of_bool(param.collapsed) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(param.selectedText) + "}")))))))))))));
}

function map(mapDomNode, snapshot) {
  if (snapshot) {
    return /* Range */{
            _0: mapRange(mapDomNode, snapshot._0)
          };
  } else {
    return /* NoRange */0;
  }
}

function stringify(stringifyDomNode, snapshot) {
  if (snapshot) {
    return "Range(" + (stringifyRange(stringifyDomNode, snapshot._0) + ")");
  } else {
    return "NoRange";
  }
}

var Generic = {
  range_encode: range_encode,
  range_decode: range_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  mapRange: mapRange,
  stringifyRange: stringifyRange,
  map: map,
  stringify: stringify
};

function fromDomSelection(selection) {
  var match = selection.rangeCount;
  if (match === 0) {
    return /* NoRange */0;
  }
  var range = selection.getRangeAt(0);
  return /* Range */{
          _0: {
            rootNode: range.commonAncestorContainer,
            startNode: range.startContainer,
            startOffset: range.startOffset,
            endNode: range.endContainer,
            endOffset: range.endOffset,
            collapsed: range.collapsed,
            selectedText: selection.toString()
          }
        };
}

function capture(param) {
  var arg = Belt_Option.map(Caml_option.nullable_to_opt(window.getSelection()), fromDomSelection);
  var param$1 = /* NoRange */0;
  return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}

var Regular = {
  fromDomSelection: fromDomSelection,
  capture: capture
};

function t_encode$1(v) {
  return t_encode(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function t_decode$1(v) {
  return t_decode(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

var ForSerialization = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* DOM__Node-SmartcutsMacros Not a pure module */
